export default __webpack_public_path__ + "static/media/alibaba-cloud-icon.e0025449.svg";